import type {Word} from "$lib/classes/data/word";
import type {WordId} from "$lib/classes/data/_primitives";

export function calculateNext(words: Word[], wordId: WordId) {
    let length = words.length
    let index = words.findIndex(dW => dW.id === wordId)
    let isLastWord = index === length - 1
    let next
    if (length > 1) {
        if (isLastWord) next = words[index - 1]
        else next = words[index + 1]
    }
    return next
}
